exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button[data-v-271bea77]{transition:background-color .2s;border:1px solid #000;background:none;padding:5px 10px;border-radius:3px;margin:0;background-color:rgba(80,80,80,.8);color:#fff;font-size:14px}.button[data-v-271bea77]:hover{background-color:hsla(0,0%,43%,.8)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-271bea77","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Button.vue
// module id = 42
// module chunks = 0